;(function () {
  'use strict'

  angular
    .module('contrast.filtering')
    .factory('LoadFilterRouteService', [
      '$location',
      'UserService',
      'LoadFilterService',
      'SERVER_ENVIRONMENT',
      LoadFilterRouteService
    ])

  function LoadFilterRouteService(
    $location,
    UserService,
    LoadFilterService,
    SERVER_ENVIRONMENT
  ) {
    return {
      goToUnlicensedApps: goToUnlicensedApps,
      goToApps: goToApps,
      goToAppsWithServers: goToAppsWithServers,
      goToFilteredServers: goToFilteredServers,
      goToServersFilteredByApp: goToServersFilteredByApp,
      buildURLToServersFilteredByApp: buildURLToServersFilteredByApp,
      buildURLToApplicationLibraries: buildURLToApplicationLibraries,
      buildURLToOrganizationLibraries: buildURLToOrganizationLibraries,
      buildURLToServerLibraries: buildURLToServerLibraries,
      goToAttackEventsFilteredByApp: goToAttackEventsFilteredByApp,
      goToOrganizationVulnerabilities: goToOrganizationVulnerabilities,
      goToApplicationVulnerabilities: goToApplicationVulnerabilities,
      goToServerVulnerabilities: goToServerVulnerabilities
    }

    function goToUnlicensedApps() {
      goToApps('UNLICENSED')
    }

    function goToApps(quickFilter, language) {
      LoadFilterService.setApplicationsQuickFilter(quickFilter)
      if (language) {
        LoadFilterService.setApplicationLanguage(language)
      }
      var queryString = buildQueryParameters({
        quickFilter: quickFilter,
        language: language
      })
      $location.url(UserService.buildUrl('/applications') + queryString)
    }

    function goToAppsWithServers(servers) {
      LoadFilterService.setServers(servers)

      var queryString = buildQueryParameters({
        servers: servers
      })
      $location.url(UserService.buildUrl('/applications') + queryString)
    }

    function goToFilteredServers(quickFilter, environment) {
      if (angular.isDefined(SERVER_ENVIRONMENT[environment])) {
        LoadFilterService.setEnvironment(environment)
      }
      LoadFilterService.setServersQuickFilter(quickFilter)

      var queryString = buildQueryParameters({
        quickFilter: quickFilter,
        environment: environment !== 'ALL' ? environment : undefined
      })
      $location.url(UserService.buildUrl('/servers') + queryString)
    }

    function goToServersFilteredByApp(appId, environment) {
      var url = buildURLToServersFilteredByApp(appId, environment)
      $location.url(url)
    }

    function buildURLToServersFilteredByApp(appId, environment) {
      if (angular.isDefined(SERVER_ENVIRONMENT[environment])) {
        LoadFilterService.setEnvironment(environment)
      }
      LoadFilterService.setServerApplications(appId)
      var queryString = buildQueryParameters({
        appID: appId,
        environment: environment
      })

      return UserService.buildUrl('/servers') + queryString
    }

    function buildURLToApplicationLibraries(appID, vulnerableLibraries) {
      return (
        UserService.buildUrl('/applications/' + appID + '/libs') +
        buildLibrariesQuickFilter(vulnerableLibraries)
      )
    }

    function buildURLToOrganizationLibraries(vulnerableLibraries) {
      return (
        UserService.buildUrl('/libraries') +
        buildLibrariesQuickFilter(vulnerableLibraries)
      )
    }

    function buildURLToServerLibraries(serverID) {
      return UserService.buildUrl(
        '/servers/' + serverID + '/libraries?quickFilter=ALL'
      )
    }

    function buildLibrariesQuickFilter(vulnerableLibraries) {
      if (vulnerableLibraries) {
        LoadFilterService.setVulnerableLibraries(true)
      }

      return buildQueryParameters({
        quickFilter: vulnerableLibraries ? 'VULNERABLE' : undefined
      })
    }

    function goToOrganizationVulnerabilities(filters) {
      var queryString = buildQueryParameters(filters)
      LoadFilterService.setVulnerabilitiesFilter(filters)
      $location.url(UserService.buildUrl('/vulns') + queryString)
    }

    function goToApplicationVulnerabilities(filters, appID) {
      if (appID) {
        var queryString = buildQueryParameters(filters)
        LoadFilterService.setVulnerabilitiesFilter(filters)
        $location.url(
          UserService.buildUrl('/applications/' + appID + '/vulns') +
            queryString
        )
      }
    }

    function goToServerVulnerabilities(filters, serverID) {
      if (serverID) {
        var queryString = buildQueryParameters(filters)
        LoadFilterService.setVulnerabilitiesFilter(filters)
        $location.url(
          UserService.buildUrl('/servers/' + serverID + '/vulns') + queryString
        )
      }
    }

    function goToAttackEventsFilteredByApp(appId) {
      LoadFilterService.setAttackEventApps([appId])
      LoadFilterService.setAttacksLive(true)
      $location.url(UserService.buildUrl('/attacks/events'))
    }

    function buildQueryParameters(filters) {
      var categoryMap = {
        tags: 'tags',
        language: 'languages',
        severity: 'severities',
        status: 'statuses',
        vulntype: 'types',
        appversiontags: 'buildNumbers',
        servers: 'servers',
        'servers-environment': 'environments',
        url: 'urls',
        modules: 'applications',
        'security-standard': 'securityStandards',
        'route-coverage': 'routes',
        apps: 'applications',
        appID: 'applications',
        languages: 'languages',
        licenses: 'licenses',
        environment: 'environments'
      }

      var queryString = '?'

      Object.keys(filters).forEach(function (parameter) {
        var convertedParameter = categoryMap[parameter]
          ? categoryMap[parameter]
          : parameter

        if (typeof filters[parameter] === 'string') {
          queryString =
            queryString + convertedParameter + '=' + filters[parameter]
          queryString += '&'
        }
        if (typeof filters[parameter] === 'object') {
          filters[parameter].forEach(function (value) {
            queryString = queryString + convertedParameter + '=' + value
            queryString += '&'
          })
        }
      })
      // Remove last '&'
      return queryString.substring(0, queryString.length - 1)
    }
  }
})()
